<style>
    /* Set the page size to A4 and the orientation to landscape */
    @page {
        size: A4 landscape;
    }

    /* Set the font size to 12px for printing */
    @media print {
        body {
            font-size: 12px;
        }
    }

    #logo {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 200px;
        height: 100px;
    }

    #title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
    }

    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #no-border {
        border: none;
    }

    td, th {
        border: 2px solid #000000;
        text-align: left;
        padding: 8px;
    }

    .remove_border tr th{
        border: none;
    }

    #table-list {
        margin-top: 80px;
    }

    #info {
        margin-top: 20px;
        width: 40%;
        float: left;
        margin-bottom: 20px;
    }

    .space-for-logo {
        width: 200px;
        height: 100px;
    }
</style>

<template>
    <div>
        <!-- <img :src="logoSDN" id="logo" /> -->
        <p id="title">Work Order Execution - Execution</p>
        <div class="space-for-logo"></div>
        <div id="info">
            <table class="remove_border">
                <tr>
                    <th>Work Order ID</th>
                    <th>:</th>
                    <th>{{ woCode }}</th>
                </tr>
                <tr>
                    <th>Work Order Description</th>
                    <th>:</th>
                    <th>{{ description }}</th>
                </tr>
                <tr>
                    <th>Bill Of Material ID</th>
                    <th>:</th>
                    <th>{{ bomCode }}</th>
                </tr>
                <tr>
                    <th>Warehouse</th>
                    <th>:</th>
                    <th>{{ warehouseName }}</th>
                </tr>
            </table>
        </div>
        <table id="table-list">
            <thead>
                <h1>Component Material</h1>
                <tr></tr>
                <tr>
                    <th style="vertical-align: middle; text-align: center;" rowspan="2">SKU Code</th>
                    <th style="vertical-align: middle; text-align: center;" rowspan="2">SKU Description</th>
                    <th style="vertical-align: middle; text-align: center;" rowspan="2">HU</th>
                    <th style="vertical-align: middle; text-align: center;" rowspan="2">Qty</th>
                    <th style="text-align: center;" colspan="3">Actual</th>
                </tr>
                <tr>
                    <th style="text-align: center;">Storage Area</th>
                    <th style="text-align: center;">Batch Number</th>
                    <th style="text-align: center;">Expired Date</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(tr, index) in skuLines">
                    <tr :key="index">
                        <td class="align-top" :rowspan="skuLines[index].actual_lines.length"
                        >{{ tr.sku_code }}</td>
                        <td class="align-top" :rowspan="skuLines[index].actual_lines.length"
                        >{{ tr.item_name }}</td>
                        <td class="align-top" :rowspan="skuLines[index].actual_lines.length"
                        >{{ tr.unit }}</td>
                        <td class="align-top" :rowspan="skuLines[index].actual_lines.length"
                        >{{ tr.qty }}</td>
                        <td>{{ tr.actual_lines[0].storage_area }}</td>
                        <td>{{ tr.actual_lines[0].batch_number }}</td>
                        <td>{{ formatDate(tr.actual_lines[0].expired_date) }}</td>
                    </tr>

                    <template v-for="(trx, indexActual) in skuLines[index].actual_lines">
                        <tr :key="index + '-' + indexActual" v-if="indexActual > 0">
                            <td class="td">{{ trx.storage_area }}</td>
                            <td class="td">{{ trx.batch_number }}</td>
                            <td class="td">{{ formatDate(trx.expired_date) }}</td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
        <table id="table-list">
            <thead>
                <h1>Result Material</h1>
                <tr></tr>
                <tr>
                    <th style="vertical-align: middle; text-align: center;">SKU Code</th>
                    <th style="vertical-align: middle; text-align: center;">SKU Description</th>
                    <th style="vertical-align: middle; text-align: center;">HU</th>
                    <th style="vertical-align: middle; text-align: center;">Planned Qty</th>
                    <th style="vertical-align: middle; text-align: center;">Actual Qty</th>
                    <th style="vertical-align: middle; text-align: center;">Delta</th>
                    <th style="vertical-align: middle; text-align: center;">Settlement</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(tr, index) in parentLines" :key="index">
                    <td>{{ tr.sku_code }}</td>
                    <td>{{ tr.item_name }}</td>
                    <td>{{ tr.unit }}</td>
                    <td>{{ tr.qty }}</td>
                    <td>{{ tr.actual_qty }}</td>
                    <td>{{ tr.delta_qty }}</td>
                    <td>Expense</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment-timezone";
import logoSDN from "../../../assets/images/logo/logo-sdn.png";
export default {
    name: "PrintPdf",
    data() {
        return {
            id: null,
            table: this.tableDefaultState(),
            woCode: null,
            description: null,
            bomCode: null,
            warehouseName: null,
            parentLines: [
                {
                    sku_code: null,
                    item_name: null,
                    unit: null,
                    qty: 0,
                    actual_qty: 0,
                    delta_qty: 0,
                    selectedSettlement: null,
                }
            ],
            skuLines: [
                {
                    line_id: 0,
                    sku_code: null,
                    item_name: null,
                    unit: null,
                    qty: 0,
                    actual_lines: [
                        {
                            item_stock_id: 0,
                            selected_hu: null,
                            qty: 0,
                            storage_area: null,
                            batch_number: null,
                            expired_date: null,
                        },
                    ],
                }
            ],
            logoSDN: logoSDN,
            showInfo: false,
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id) {
            console.log(this.id)
            this.print();
        }
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
            };
        },
        async print() {
            await this.getData()
            await window.print()
        },
        async getData() {
            this.$vs.loading();
            let resp = await this.$http.get(
                "/api/wms/v1/work-order-execution/execute-form/" + this.id
            );
            if (resp.code == 200) {
                this.woCode = resp.data.wo_code
                this.description = resp.data.wo_description
                this.bomCode = resp.data.bom_code
                this.warehouseName = resp.data.warehouse_name
                this.parentLines = resp.data.parent_lines
                this.skuLines = resp.data.sku_lines
                this.table.data = resp.data
                this.$vs.loading.close();
            } else {
                this.$vs.loading.close();
            }

            this.parentLines.forEach((val) => {
                if (val.actual_qty != null) {
                    val.delta_qty = val.qty - val.actual_qty
                }
            })
        },
    },
    computed: {
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
    },
}
</script>